export default (axios) => ({
  getBanners(params) {
    // return axios.get('/launchManage/getWebsite?language=en-US&launchSeat=banners')
    return axios({
      method: 'get',
      url: '/launchManage/getWebsite',
      params
    })
  },
  queryIpInfo(ip) {
    return axios.get('/ip/query', {
      params: {
        ip
      }
    })
  },
  subscribe(data) {
    return axios({
      url: '/public/subscribe/add',
      data,
      method: 'post'
    })
    // return .post('/public/subscribe/add', data)
  },
  getvideoList(params) {
    return axios({
      url: '/productVideo/getByWebsite',
      params,
      method: 'get'
    })
  },
  getCountryByIp(params) {
    return axios({
      method: 'get',
      url: '/statistics/getCountryByIp',
      params
    })
  },
  // KOL 视频
  getInfluencerVideo(params) {
    return axios({
      url: '/influencerVideo/getByPage',
      params,
      method: 'get'
    })
  }
})
